import { render, staticRenderFns } from "./DentalView.vue?vue&type=template&id=72c22681&"
import script from "./DentalView.vue?vue&type=script&lang=js&"
export * from "./DentalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports